import { useUpdateStoreCanReceiveEmailMutation } from "@/services/conciliation/store-email";
import React from "react";

interface Props {
  code: string;
  value: boolean;
}

export const CanReceiveEmailToggle: React.FC<Props> = ({ code, value }) => {
  const [updateStoreCanReceiveEmail, { isLoading }] = useUpdateStoreCanReceiveEmailMutation();

  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    await updateStoreCanReceiveEmail({
      storeCode: code,
      canReceiveEmail: e.target.checked ? "true" : "false"
    });
  };

  return (
    <input
      type="checkbox"
      checked={value}
      disabled={isLoading}
      onChange={handleChange}
      className={
        `form-checkbox h-4 w-4 rounded border-gray-300 transition duration-150 ease-in-out ` +
        (value ? 'checked:bg-[#2E0D1E] checked:border-[#2E0D1E] checked:accent-[#2E0D1E]' : '')
      }
      style={{ cursor: isLoading ? "not-allowed" : "pointer" }}
    />
  );
};
